import uniqueId from 'lodash/uniqueId';
import Slider from '../../../molecules/Slider';
import JobTeaser from '../../../molecules/JobTeaser';

/**
 * @param {JobTeaserOverviewProps} props
 */
const JobTeaserOverviewMobile = ({ teasers, isDarkMode }) => {
  return (
    <Slider
      narrow={true}
      content={teasers.map((teaser) => (
        <JobTeaser {...teaser} key={uniqueId('mobileJobTeaser')} />
      ))}
      isDarkMode={isDarkMode}
    />
  );
};

export default JobTeaserOverviewMobile;
